import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Form,
    Input,
    Select,
    Modal,
    Typography,
    Button,
    DatePicker,
    notification,
    Alert,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import ProductionApi from "../../Apis/ProductionApi";
import ReheatProcessApi from "../../Apis/ReheatProcessApi";
import { AudioOutlined, InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";
const { Title } = Typography;
function AddTemp({ visible, onClose, ProductctionDetails }) {
    const [formAdd] = Form.useForm();
    const navigate = useNavigate();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    formAdd.setFieldsValue({
        productId: ProductctionDetails?.recipeDTO?.id,
        batchCode: ProductctionDetails?.batchCode,
    });

    const [Production, setProduction] = React.useState([]);
    const getProduction = useCallback(() => {
        ProductionApi.ListProduction2()
            .then((response) => {
                console.log(response)
                setProduction(response?.payloadDto);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);


    useEffect(() => {
        getProduction();
    }, [getProduction]);

    const handleChangeProduct = (value) => {
        ProductionApi.SingleProduction(value)
            .then((response) => {
                console.log(response?.payload)
                formAdd.setFieldsValue({
                    batchCode: response?.payload?.batchCode,
                });
            })
            .catch((err) => {
                console.log(err);
            });

    };
    const [Correctvalid, setCorrectvalid] = useState(false);
    const handleInputChange = (event) => {
        const newItem = event.target.value.trim();
        if (parseInt(newItem) < 75) {
            setCorrectvalid(true)
        } else {
            setCorrectvalid(false)
        }

    };
    const handleSubmit = (data) => {


        const sellDate = dayjs(data.OUBD).format("DD/MM/YYYY");
        let formData = JSON.stringify({
            correctiveAction: Correctvalid ? data.correctiveAction : "N/A",
            temperatureInCelsius: data.Temperature,
            ubd: convertToUnixTimestamp(sellDate),
            productionDTO: {
                id: ProductctionDetails?.id,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });
        console.log(formData)
        ReheatProcessApi.CreatereheatProcess(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Created</span>,
                    description: "Created Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch((err) => {
                console.log(err);
                // Error Notification
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });

    };
    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }
    const currentDate = moment().format("DD/MM/YYYY");


    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };
    const handleInput = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            e.target.value = value;
        } else {
            // Remove any non-numeric or extra decimal characters
            e.target.value = value.slice(0, -1);
        }
    };
    const [isRecording, setIsRecording] = useState(false);
    const startRecording = (fieldN) => {

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = 'en-US';
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            let fieldName = fieldN;

            formAdd.setFieldsValue({
                [fieldName]: transcript,
            });
        };

        recognition.start();
        if (fieldN === 'Temperature') {
            setIsRecording(true);
        }
    };

    const stopRecording = () => {
        setIsRecording(false);
    };
    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Reheat
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <div className="mb-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                />
                            </div>
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <DatePicker
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item
                            name="productId"
                            label="Production :"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Production.",
                                },
                            ]}
                        >
                            <Select
                                disabled
                                className="control-Select  mb-3"
                                placeholder="Select Production"
                                onChange={(value) =>
                                    handleChangeProduct(value)
                                }
                            >
                                {Production && (
                                    <>
                                        {Production?.map((option, index) => (
                                            <option key={index} value={option?.recipeDTO?.id}>
                                                {option?.recipeDTO?.recipeName}
                                            </option>
                                        ))}
                                    </>
                                )}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="batchCode"
                            label="Batch Code"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Batch Code.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                disabled
                                placeholder="Batch Code"
                                className="control-input"
                            />
                        </Form.Item>


                        <Form.Item
                            name="OUBD"
                            label="UBD"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select UBD.",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="Temperature"
                            label="Temperature"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                onChange={(event) => handleInputChange(event)}
                                placeholder="0"
                                className="control-input col-6"
                                style={{
                                    border: 'none',
                                    textAlign: 'end',
                                    padding: '0px'
                                }}
                                addonAfter={
                                    <>
                                        <Button
                                            className="StockTempClass"
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                paddingTop: '0px',
                                                margin: 0,
                                                background: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            'C
                                        </Button>
                                        <Button
                                            onMouseDown={() => startRecording('Temperature')}
                                            onMouseUp={stopRecording}
                                            onMouseLeave={stopRecording}
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                marginLeft: '10px',
                                                paddingLeft: '5px',
                                                paddingBottom: '5px',
                                                background: 'none',
                                                borderRadius: '0px',
                                                borderLeft: '1px solid #d9d9d9',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                                        </Button>
                                    </>
                                }
                            />
                        </Form.Item>
                        {/* <p style={{ textAlign: 'center', fontSize: '13px', color: 'blue' }}  ><InfoCircleFilled style={{ fontSize: '9px' }} className="inforIcon" /> Temperature should be above 75℃</p> */}
                        <Alert message="Temperature should be above 75℃" type="info" className="temp-info-text" />
                        <Form.Item
                            name="correctiveAction"
                            label="Corrective Action"
                            className={Correctvalid ? 'text-lable' : 'd-none'}
                            rules={Correctvalid ? [
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ] : []}
                        >
                            <Input
                                type="text"
                                placeholder="Corrective Action"
                                className="control-input"
                            />
                        </Form.Item>





                        {/* <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Create
                            </Button>
                            <Link
                                type="primary"
                                to={""}
                                className="btn btn-primary btn-back mx-2 w-20"
                                style={{ width: "37%" }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Link>
                        </div> */}

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                            }}
                        >
                            <Button
                                onClick={handleCancel}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#000",
                                    textDecoration: "none",
                                    fontWeight: 500,
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    fontWeight: 500,
                                }}
                            >
                                Save Temperature & Continue
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddTemp;
